
      // ローディング画面の制御
      window.addEventListener('load', () => {
        setTimeout(() => {
          const loading = document.getElementById('loading');
          if (loading) {
            loading.classList.add('hidden');
            setTimeout(() => {
              loading.remove();
            }, 500);
          }
        }, 2000);
      });
      
      // エラーハンドリング
      window.addEventListener('error', (event) => {
        console.error('Application Error:', event.error);
        const loading = document.getElementById('loading');
        if (loading) {
          loading.innerHTML = `
            <div class="loading-avatar">⚠️</div>
            <div class="loading-text">エラーが発生しました</div>
            <p style="margin-top: 20px; opacity: 0.8;">ページを再読み込みしてください</p>
          `;
        }
      });
      
      // カメラ・マイクのアクセス許可チェック
      async function checkPermissions() {
        try {
          // カメラ許可チェック
          const videoStream = await navigator.mediaDevices.getUserMedia({ video: true });
          videoStream.getTracks().forEach(track => track.stop());
          
          // マイク許可チェック
          const audioStream = await navigator.mediaDevices.getUserMedia({ audio: true });
          audioStream.getTracks().forEach(track => track.stop());
          
          console.log('✅ Camera and microphone permissions granted');
        } catch (error) {
          console.warn('⚠️ Camera/microphone permission required:', error);
        }
      }
      
      // ブラウザ互換性チェック
      function checkBrowserCompatibility() {
        const features = {
          'getUserMedia': !!navigator.mediaDevices?.getUserMedia,
          'WebRTC': !!window.RTCPeerConnection,
          'SpeechRecognition': !!(window.SpeechRecognition || window.webkitSpeechRecognition),
          'Fetch API': !!window.fetch,
          'ES Modules': true
        };
        
        const unsupported = Object.entries(features)
          .filter(([_, supported]) => !supported)
          .map(([feature]) => feature);
        
        if (unsupported.length > 0) {
          console.warn('⚠️ Unsupported features:', unsupported);
        } else {
          console.log('✅ All features supported');
        }
      }
      
      // 初期化処理
      checkBrowserCompatibility();
      checkPermissions();
    